import React from 'react'
import {connect} from "react-redux";
import {createStructuredSelector} from "reselect"
import {
	onCloseStartScreen,
	_handleSelectLocationFromGeocoder,
	selectCommunityAndFetchItsGeoIdLookupData
} from "../../Redux/Actions/mapActions";
import {
	showStartScreenSelector,
	initialLoadOfMapHasCompletedSelector,
	_mapRefSelector,
} from "../../Redux/selectors";

import DataManager from "../../DataManagers/DataManager";
import LocalPerspectiveStartScreen from "./LocalPerspectiveStartScreen";
import ChoseUSStatesStartScreen from "./ChoseUSStatesStartScreen";


const StartScreenHOC = React.memo(
	({...props}) => {
		const startScreenOption = DataManager.getStartScreenOption()
		const START_SCREEN_OPTIONS = DataManager.getStartScreenOptions()
		
		if (!props.showStartScreen) {
			return null
		}
		
		switch (startScreenOption) {
			case START_SCREEN_OPTIONS.LOCAL_PERSPECTIVE_START_SCREEN:
				return <LocalPerspectiveStartScreen {...props} />
			case START_SCREEN_OPTIONS.CHOOSE_US_STATES_START_SCREEN:
				return <ChoseUSStatesStartScreen />
			default:
				console.error(`Something went wrong with your Start Screen selection: ${startScreenOption} does not match the the options in `, START_SCREEN_OPTIONS)
				return null
		}
	}
)


// Redux

const mapStateToProps = createStructuredSelector({
	showStartScreen: showStartScreenSelector,
	initialLoadOfMapHasCompleted: initialLoadOfMapHasCompletedSelector,
	
	_mapRef: _mapRefSelector,
})

// Redux AND es6 shorthand formats for the Actions to inject into props with access to the dispatch function
const mapDispatchToProps = {
	onCloseStartScreen,
	_handleSelectLocationFromGeocoder,
	selectCommunityAndFetchItsGeoIdLookupData,
}

export default connect(mapStateToProps, mapDispatchToProps)(StartScreenHOC)
